import * as React from 'react'
import { UploadedImageWidget } from './UploadedImageWidget'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const UploadedImageWidgetExamples = () => {
  return (
    <div className="UploadedImageWidgetExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <UploadedImageWidget />
      </Provider>
    </div>
  )
}
